import { render, staticRenderFns } from "./custom-upload.vue?vue&type=template&id=28fca61e&"
import script from "./custom-upload.vue?vue&type=script&lang=js&"
export * from "./custom-upload.vue?vue&type=script&lang=js&"
import style0 from "./custom-upload.vue?vue&type=style&index=0&id=28fca61e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports